import { IOrderBump, IProductOrderBump } from 'interfaces/orderbump';
import { Observable } from 'rxjs';

import apiService, { ApiService } from './api';

export class OrderBumpService {
  constructor(private api: ApiService) {}

  public getProducts(): Observable<IProductOrderBump[]> {
    return this.api.get('/orderbump/mainproducts');
  }

  public getBumpProducts(idProduct: number): Observable<IProductOrderBump[]> {
    return this.api.get(`/orderbump/bumpproducts/${idProduct}`);
  }

  public createOrderBump(productId: number, bumpId: number, description: string): Observable<any> {
    const data = { productId, bumpId, description };
    return this.api.post('/orderbump/register', data);
  }

  public getOrderBumpsProducer(): Observable<IOrderBump[]> {
    return this.api.get('/orderbump');
  }

  public getOrderBumpsProduct(idProduct: string): Observable<any[]> {
    return this.api.get(`/orderbump/${idProduct}`);
  }

  public updateOrderBump(orderBumpId: number, ownerId: number, bumpId: number, description: string, ativo: number) {
    const data = { orderBumpId, ownerId, bumpId, description, ativo };
    return this.api.post('/orderbump/update', data);
  }
}

export const OrderBumpServiceFactory = () => new OrderBumpService(apiService);

export const orderBumpService = OrderBumpServiceFactory();
